import { Clock, ArrowUpRight } from "lucide-react";
import { ORDER_URL } from "../../config/preview";

// Full-screen replacement when the preview window has passed.
export function ExpiredScreen() {
  return (
    <div
      data-testid="expired-screen"
      className="fixed inset-0 z-[10000] bg-slate-950 text-slate-100 flex items-center justify-center p-6"
    >
      <div className="max-w-md w-full text-center">
        <div className="mx-auto h-14 w-14 rounded-sm bg-slate-900 border border-slate-800 flex items-center justify-center">
          <Clock size={22} strokeWidth={1.5} className="text-slate-400" />
        </div>
        <h1 className="font-display text-3xl font-semibold tracking-tight text-white mt-6">
          This preview has expired.
        </h1>
        <p className="text-sm text-slate-400 mt-3 leading-relaxed">
          Complete your payment to restore access to your MVP.
        </p>
        <a
          href={ORDER_URL}
          target="_blank"
          rel="noopener"
          data-testid="expired-cta"
          className="mt-8 inline-flex items-center gap-1.5 rounded-sm bg-white text-slate-950 hover:bg-slate-200 px-5 py-2.5 text-sm font-medium transition-colors"
        >
          Complete payment <ArrowUpRight size={14} strokeWidth={2.25} />
        </a>
        <p className="text-[11px] text-slate-500 mt-10 leading-relaxed">
          Concept, design and code remain the property of Rockstars Digitals until payment has been received in full.
        </p>
      </div>
    </div>
  );
}
